import * as React from "react";
import { forwardRef, memo } from "react";
const SvgCo = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 6 4", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("rect", { fill: "#CE1126", width: 6, height: 4 }), /* @__PURE__ */ React.createElement("rect", { fill: "#003893", width: 6, height: 3 }), /* @__PURE__ */ React.createElement("rect", { fill: "#FCD116", width: 6, height: 2 }));
const ForwardRef = forwardRef(SvgCo);
const Memo = memo(ForwardRef);
export default Memo;
